module.exports = __webpack_public_path__ + "media/packs/site/assets/images/watermark2-c31b1bc85c03b53960f657aaf374739c.svg";